import React, { useEffect, useState } from 'react';

const s = {
  section: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #050815 0%, #080d20 60%, #050815 100%)',
    display: 'flex', alignItems: 'center',
    padding: '120px 0 80px',
    position: 'relative', overflow: 'hidden',
  },
  glow1: {
    position: 'absolute', top: '10%', left: '-10%',
    width: 600, height: 600,
    background: 'radial-gradient(circle, rgba(108,99,255,0.12) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  glow2: {
    position: 'absolute', top: '30%', right: '-5%',
    width: 500, height: 500,
    background: 'radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  grid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr',
    gap: 60, alignItems: 'center',
    maxWidth: 1100, margin: '0 auto', padding: '0 24px',
  },
  tag: {
    display: 'inline-flex', alignItems: 'center', gap: 8,
    background: 'rgba(108,99,255,0.1)',
    border: '1px solid rgba(108,99,255,0.3)',
    borderRadius: 100, padding: '6px 16px',
    fontSize: 12, fontFamily: 'Sora, sans-serif', fontWeight: 500,
    color: '#a5a0ff', marginBottom: 28,
    animation: 'fadeInUp 0.6s ease',
  },
  dot: { width: 7, height: 7, borderRadius: '50%', background: '#6c63ff', animation: 'pulse-glow 2s infinite' },
  h1: {
    fontFamily: 'Sora, sans-serif', fontSize: 54, fontWeight: 800,
    lineHeight: 1.1, marginBottom: 24,
    animation: 'fadeInUp 0.6s ease 0.1s both',
  },
  purple: {
    background: 'linear-gradient(135deg, #6c63ff, #818cf8)',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
  desc: {
    color: '#8892b0', fontSize: 16, lineHeight: 1.7,
    maxWidth: 460, marginBottom: 28,
    fontFamily: 'DM Sans, sans-serif',
    animation: 'fadeInUp 0.6s ease 0.2s both',
  },
  checks: {
    display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 36,
    animation: 'fadeInUp 0.6s ease 0.3s both',
  },
  checkItem: {
    display: 'flex', alignItems: 'center', gap: 10,
    fontSize: 14, color: '#c0c8e0', fontFamily: 'DM Sans, sans-serif',
  },
  checkIcon: {
    width: 20, height: 20, borderRadius: '50%',
    background: 'rgba(108,99,255,0.2)', border: '1px solid rgba(108,99,255,0.4)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 10, color: '#6c63ff', flexShrink: 0,
  },
  btns: {
    display: 'flex', gap: 16, alignItems: 'center',
    animation: 'fadeInUp 0.6s ease 0.4s both',
  },
  btnPrimary: {
    background: 'linear-gradient(135deg, #6c63ff, #4f46e5)',
    color: '#fff', border: 'none', padding: '14px 28px',
    borderRadius: 10, fontSize: 15, fontFamily: 'Sora, sans-serif', fontWeight: 600,
    cursor: 'pointer', transition: 'all 0.2s',
    boxShadow: '0 8px 25px rgba(108,99,255,0.4)',
    display: 'flex', alignItems: 'center', gap: 8,
  },
  btnSecondary: {
    background: 'transparent', color: '#c0c8e0',
    border: '1px solid rgba(255,255,255,0.12)',
    padding: '14px 28px', borderRadius: 10,
    fontSize: 15, fontFamily: 'Sora, sans-serif', fontWeight: 500,
    cursor: 'pointer', transition: 'all 0.2s',
    display: 'flex', alignItems: 'center', gap: 8,
  },
  stats: {
    display: 'flex', gap: 40, marginTop: 56,
    animation: 'fadeInUp 0.6s ease 0.5s both',
  },
  statNum: {
    fontFamily: 'Sora, sans-serif', fontSize: 28, fontWeight: 800,
    color: '#6c63ff',
  },
  statLabel: { fontSize: 12, color: '#8892b0', marginTop: 2, fontFamily: 'DM Sans, sans-serif' },
  // Right side - visual mockup
  visual: {
    position: 'relative',
    animation: 'fadeInUp 0.8s ease 0.3s both',
  },
  mockup: {
    background: 'linear-gradient(135deg, #0d1229 0%, #141830 100%)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 20, padding: 20,
    boxShadow: '0 40px 80px rgba(0,0,0,0.5), 0 0 0 1px rgba(108,99,255,0.1)',
    animation: 'float 6s ease-in-out infinite',
    overflow: 'hidden',
  },
  mockupBar: {
    display: 'flex', gap: 6, marginBottom: 16,
    alignItems: 'center',
  },
  dot1: { width: 10, height: 10, borderRadius: '50%', background: '#ff5f57' },
  dot2: { width: 10, height: 10, borderRadius: '50%', background: '#febc2e' },
  dot3: { width: 10, height: 10, borderRadius: '50%', background: '#28c840' },
  mockupContent: { minHeight: 240 },
  fileGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 },
  fileCard: {
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 10, padding: 12, cursor: 'pointer',
    transition: 'all 0.2s',
  },
  fileIcon: { fontSize: 22, marginBottom: 8 },
  fileName: { fontSize: 10, color: '#8892b0', fontFamily: 'Sora, sans-serif', lineHeight: 1.3 },
  badge: {
    position: 'absolute', top: 20, right: -10,
    background: 'linear-gradient(135deg, #6c63ff, #4f46e5)',
    borderRadius: 12, padding: '8px 14px',
    display: 'flex', alignItems: 'center', gap: 8,
    boxShadow: '0 8px 25px rgba(108,99,255,0.5)',
    animation: 'float 4s ease-in-out infinite 1s',
  },
  badgeText: { fontSize: 11, color: '#fff', fontFamily: 'Sora, sans-serif', fontWeight: 600 },
  badge2: {
    position: 'absolute', bottom: 30, left: -20,
    background: 'rgba(13,18,41,0.95)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 12, padding: '10px 16px',
    display: 'flex', alignItems: 'center', gap: 10,
    boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
    backdropFilter: 'blur(10px)',
    animation: 'float 5s ease-in-out infinite 0.5s',
  },
  badge2Dot: {
    width: 8, height: 8, borderRadius: '50%', background: '#22c55e',
    boxShadow: '0 0 8px rgba(34,197,94,0.6)',
  },
};

const files = [
  { icon: '📄', name: 'Contrato_2024.pdf' },
  { icon: '📊', name: 'Reporte_Q3.xlsx' },
  { icon: '🖼️', name: 'Branding_v2.png' },
  { icon: '📝', name: 'Propuesta.docx' },
  { icon: '🗂️', name: 'Facturas_Dic' },
  { icon: '📁', name: 'Recursos HR' },
];

export default function Hero() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section style={s.section} id="inicio">
      <div style={s.glow1} />
      <div style={s.glow2} />
      <div style={s.grid}>
        {/* Left */}
        <div>
          <div style={s.tag}>
            <div style={s.dot} />
            Sistema Empresarial de Gestión de Archivos
          </div>
          <h1 style={s.h1}>
            Gestiona tus{' '}
            <span style={s.purple}>archivos<br />empresariales</span>{' '}
            con total control
          </h1>
          <p style={s.desc}>
            ArchiVex centraliza la gestión documental de tu empresa con soporte
            multi-empresa, control de versiones, permisos avanzados y colaboración
            en tiempo real para todos tus equipos.
          </p>
          <div style={s.checks}>
            {['Multi-empresa y multi-usuario', 'Control de versiones avanzado', 'Permisos granulares por archivo y carpeta'].map(t => (
              <div key={t} style={s.checkItem}>
                <div style={s.checkIcon}>✓</div>
                <span>{t}</span>
              </div>
            ))}
          </div>
          <div style={s.btns}>
            <button style={s.btnPrimary}
              onClick={() => scrollTo('contacto')}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
            >
              Solicitar Demo Gratis →
            </button>
            <button style={s.btnSecondary}
              onClick={() => scrollTo('beneficios')}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
            >
              ▶ Ver Beneficios
            </button>
          </div>
          <div style={s.stats}>
            {[['500+', 'Empresas activas'], ['99.9%', 'Disponibilidad garantizada'], ['10M+', 'Archivos gestionados']].map(([num, label]) => (
              <div key={label}>
                <div style={s.statNum}>{num}</div>
                <div style={s.statLabel}>{label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right - Mockup */}
        <div style={s.visual}>
          <div style={s.mockup}>
            <div style={s.mockupBar}>
              <div style={s.dot1} /><div style={s.dot2} /><div style={s.dot3} />
              <div style={{ flex: 1, height: 6, background: 'rgba(255,255,255,0.06)', borderRadius: 3, marginLeft: 8 }} />
            </div>
            <div style={s.mockupContent}>
              <div style={{ fontSize: 11, color: '#8892b0', fontFamily: 'Sora, sans-serif', marginBottom: 12 }}>
                📂 Mis Documentos / Contratos 2024
              </div>
              <div style={s.fileGrid}>
                {files.map((f, i) => (
                  <div key={i} style={s.fileCard}
                    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(108,99,255,0.1)'; e.currentTarget.style.borderColor = 'rgba(108,99,255,0.3)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'; }}
                  >
                    <div style={s.fileIcon}>{f.icon}</div>
                    <div style={s.fileName}>{f.name}</div>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 14, height: 1, background: 'rgba(255,255,255,0.05)' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, fontSize: 10, color: '#8892b0', fontFamily: 'DM Sans, sans-serif' }}>
                <span>6 elementos · 2.4 GB</span>
                <span style={{ color: '#22c55e' }}>● Sincronizado</span>
              </div>
            </div>
          </div>

          <div style={s.badge}>
            <span style={{ fontSize: 14 }}>👥</span>
            <div>
              <div style={s.badgeText}>3 Usuarios activos</div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.6)', fontFamily: 'DM Sans, sans-serif' }}>Editando ahora mismo</div>
            </div>
          </div>

          <div style={s.badge2}>
            <div style={s.badge2Dot} />
            <div>
              <div style={{ fontSize: 11, color: '#f0f4ff', fontFamily: 'Sora, sans-serif', fontWeight: 600 }}>Versión guardada</div>
              <div style={{ fontSize: 9, color: '#8892b0', fontFamily: 'DM Sans, sans-serif' }}>v3.2 · hace 2 minutos</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
